import React, { useState } from "react";

export default function Contact() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div>
      <>
        <div className="first_nav_hero_about">
          {/* ======== 1.1. header section ======== */}
          <header>
            <nav className="container navbar navbar-expand-lg ">
              <div className="container-fluid">
                {/* site logo */}
                <a className="nav-logo p-0" href="/">
                  <img src="/assets/images/new_logo.svg" alt="logo" />
                </a>
                {/* navigation button  */}
                <button
                  className="navbar-toggle"
                  onClick={toggleNavbar}
                  type="button"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                >
                  <i className="fa-solid fa-bars" />
                </button>
                {/* navigation bar manu  */}
                <div
                  className={`mobileNav collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarSupportedContent"
                >
                  <ul className="navbar-nav d-flex justify-content-center align-items-center gap-lg-2 gap-md-2 gap-sm-2 gap-2 mb-2 mb-lg-0">
                    <li className="nav-item">
                      <a className="nav-link active" href="/">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/aboutus">
                        About us
                      </a>
                    </li>
                    {/*
                    <li className="nav-item">
                      <a className="nav-link" href="/feature">
                        Solutions
                      </a>
                    </li>*/}
                    <li className="nav-item">
                      <a className="nav-link" href="/Contactus">
                        Contact Us
                      </a>
                    </li>

                    {/* <li className="nav-item">
                      <a className="nav-link" href="/FAQ">
                        FAQ's
                      </a>
                    </li>*/}
                    {/* <li className="dropdown">
                <a className="nav-link " href="#">
                  Pages <i className="fa-sharp fa-solid fa-sort-down" />
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="pricing.html">
                      Pricing
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="contact.html">
                      Contact
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="team.html">
                      Team
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="testimonials.html">
                      Testimonials
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="blogs.html">
                      Blogs
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="faq.html">
                      FAQ
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="404.html">
                      404
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="coming.html">
                      Coming Soon
                    </a>
                  </li>
                </ul>
              </li> */}
                    {/* <li className="nav-item">
                <a id="search-bar-bt" className="nav-link" href="#">
                  <i className="fa-solid fa-magnifying-glass" />
                </a>
              </li> 

                    <a className=" btn-hover4" href="#">
                      Create Account
                    </a>*/}

                    {/* <li
                className="nav-item"
                onclick="if (!window.__cfRLUnblockHandlers) return false; open_right_side()"
                data-cf-modified-2a89ad8e51888e2ea151ec41-=""
              >
                <a className="nav-link" href="#">
                  <i className="fa-sharp fa-solid fa-bars" />
                </a>
              </li> */}
                  </ul>
                </div>
              </div>
            </nav>
            {/*============ navigation left slidebar================*/}
            <aside>
              <div id="mySidenav" className="sidenav">
                <div className="side-nav-logo d-flex justify-content-between align-items-center ps-4 pe-3">
                  <figure className="navbar-brand">
                    <a href="/">
                      <img
                        src="/assets/images/new_logo.svg"
                        alt="img"
                        className="nav-logo"
                      />
                    </a>
                  </figure>
                  <div
                    className="closebtn"
                    onclick="if (!window.__cfRLUnblockHandlers) return false; closeNav()"
                    data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                  >
                    <i className="fa-solid fa-square-xmark side-bar-close-btn" />
                  </div>
                </div>
                <ul>
                  <li className="nav-item">
                    <a className="nav-link" aria-current="page" href="/">
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="about.html">
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/feature">
                      Solutions
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="pricing.html">
                      Pricing
                    </a>
                  </li>
                  <li className="nav-item">
                    <div
                      className="d-flex align-items-center justify-content-between pt-3"
                      id="slid-btn"
                    >
                      <button className="a-slid">Pages</button>
                      <i className="fa-solid fa-caret-down pe-4" />
                    </div>
                    <ul id="slid-drop" className="myst">
                      <li>
                        <a href="contact.html">Contact</a>
                      </li>
                      <li>
                        <a href="team.html">Team</a>
                      </li>
                      <li>
                        <a href="testimonials.html">Testimonials</a>
                      </li>
                      <li>
                        <a href="blogs.html">Blogs</a>
                      </li>
                      <li>
                        <a href="faq.html">FAQ</a>
                      </li>
                      <li>
                        <a href="404.html">404</a>
                      </li>
                      <li>
                        <a href="coming.html">Coming Soon</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </aside>
            {/*================== navigation drop search bar================*/}
            <div className="search" id="search-bar">
              <form className="d-flex nav-search">
                <input type="text" name="search" placeholder="Enter your text" />
                <button className="btn-hover1" type="submit">
                  Search
                </button>
              </form>
              <button id="remove-btn">
                <i className="fa-solid fa-square-xmark " />
              </button>
            </div>
            {/*=================navigation Right slidebar==================*/}
            <section className="right-sidbar" id="right_side">
              <div className="d-flex justify-content-between align-items-center">
                {/* site logo */}
                <a className="p-0 " href="/">
                  <img src="/assets/images/new_logo.svg" alt="logo" />
                </a>
                <button
                  className="close_right_sidebar fa-solid fa-xmark"
                  onclick="if (!window.__cfRLUnblockHandlers) return false; close_right_sade()"
                  data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                >
                  {" "}
                </button>
              </div>
              <p className="mt-4 pb-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <a href="#" className="btn-hover1">
                Discover More
              </a>
              <hr />
              <h5 className="mt-4 mb-4">Connected details:</h5>
              <ul className="d-flex flex-column gap-3">
                <li>
                  <a href="#">
                    {" "}
                    <i className="fa-solid fa-phone" />
                  </a>
                  <a href="#">
                    <span
                      className="__cf_email__"
                      data-cfemail="71081e04031f101c1431141c10181d5f121e1c"
                    >
                      [email&nbsp;protected]
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa-solid fa-envelope" />
                  </a>
                  <a href="#">+123-456-7890</a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa-solid fa-clock" />
                  </a>
                  <a href="#">
                    Office Hours: 8AM - 11PM Sunday - Weekend Day
                  </a>
                </li>
              </ul>
              <span className="d-flex gap-4 mt-4">
                <a href="#" className="p-0">
                  <i className="fa-brands fa-facebook" />
                </a>
                <a href="#" className="p-0">
                  <i className="fa-brands fa-instagram" />
                </a>
                <a href="#" className="p-0">
                  <i className="fa-brands fa-twitter" />
                </a>
              </span>
            </section>
          </header>
          {/* ======== End of 1.1. header section ========  */}
          {/* ======== 5.1. contact-hero section ========  */}
          <div className="container mb-10">
            <div className="contact-hero">
              <h2 className="text-center">CONTACT</h2>
              <p className="text-center">
                Have any questions or need assistance? Get in touch with our team for expert support and guidance.
              </p>
            </div>
          </div>

          {/* ======== End of 5.1. contact-hero section ========  */}
        </div>
        <section className="d-flex justify-content-center ">
          <div className="help position-relative">
            <div className="container">
              <div className="row d-flex gap-lg-5 gap-md-3 gap-sm-4 gap-3 justify-content-center">
                <div
                  className="col-lg-5 col-md-5 help-crd1"
                  data-aos="fade-down"
                  data-aos-easing="linear"
                  data-aos-duration={1500}
                >
                  <h4>HOW CAN WE HELP?</h4>
                  <p>
                    Whether you need support with our services or have inquiries about our offerings, we’re here to assist you.

                  </p>
                  <div className="d-flex gap-4 align-items-center">
                    <i className="fa-solid fa-house" />
                    <span>
                      101, Zenith Castle, Pillar No 215, Rajendra Nagar, Hyderabad 500030, Telangana - INDIA
                    </span>
                  </div>
                  <div className="d-flex gap-4 align-items-center">
                    <i className="fa-solid fa-house" />
                    <span>
                      Suite 1505, Zone B, Aspect Tower, Bay Avenue Mall, Businees Bay, DUBAI - UAE</span>
                  </div>
                  <div className="d-flex gap-4 align-items-center">
                    <i className="fa-solid fa-phone" />
                    <span>+91-40-46022444</span>
                  </div>
                  <div className="d-flex gap-4 align-items-center">
                    <i className="fa-solid fa-envelope" />
                    <span>
                      <a
                        href="../cdn-cgi/l/email-protection"
                        className="__cf_email__"
                        data-cfemail="f38a9c86819d929e96b3969e929a9fdd909c9e"
                      >
                        email.finkeypay.com
                      </a>
                    </span>
                  </div>
                  <h5>OPERATING HOURS</h5>
                  <div className="d-flex gap-4 align-items-center">
                    <i className="fa-solid fa-clock" />
                    <span>
                      Monday To Friday <br /> 8:00am to 8:00pm GST
                    </span>
                  </div>
                </div>
                <div
                  className="col-lg-5 col-md-5 contact-email"
                  data-aos="fade-down"
                  data-aos-easing="linear"
                  data-aos-duration={1500}
                >
                  <h4>EMAIL US</h4>
                  <form
                    action="#"
                    id="footer-sub"
                  >
                    <div className="row justify-content-center gap-3">
                      <input
                        type="text"
                        name="name"
                        id="name"
                        className="col-md-5 col-sm-12 col-12"
                        placeholder="Your Name"
                        required=""
                      />
                      <input
                        type="email"
                        name="email"
                        id="email"
                        className="col-md-5 col-sm-12 col-12"
                        placeholder="Email Address"
                        required=""
                      />
                      <input
                        type="number"
                        name="number"
                        id="number"
                        className="col-md-5 col-sm-12 col-12"
                        placeholder="Phone Number"
                        required=""
                      />
                      <input
                        type="text"
                        name="subject"
                        id="subject"
                        className="col-md-5 col-sm-12 col-12"
                        placeholder="Subject"
                        required=""
                      />
                      <textarea
                        className="col-md-11 col-12"
                        name="massage"
                        id="massage"
                        cols={30}
                        rows={10}
                        placeholder="Write here message"
                        defaultValue={""}
                      />
                    </div>
                    <div className="d-flex justify-content-center mt-4">
                      <button className=" e-btn btn-hover1" type="button" onClick={() => alert('Submitted Successfully')}>
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
                <div id="Succes-box" />
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 5.1. map help section ========  */}
        {/* ======== 1.13. footer section ========  */}
        <footer className="position-relative">
          <div className="container">
            <h4 className="text-center">SUBSCRIBE OUR NEWSLETTER</h4>
            <p className="text-center pt-2 pb-3">Get latest News and Updates</p>
            <form
              className="d-flex align-items-center justify-content-center"
              id="footer-sub2"
            >
              {/* form Subscribe massage */}
              <div id="Succes-box2" />
              <div className="d-flex footer-search">
                <input
                  type="email"
                  name="search"
                  placeholder="Enter your Email"
                  required=""
                />
                <button type="submit" className="btn-hover1">
                  Subscribe
                </button>
              </div>
            </form>
            <div className="footer-logo text-center pb-lg-4 pb-md-3 pb-sm-2 pb-4">
              {/* footer logo  */}
              <a href="/">
                <figure>
                  <img src="/assets/images/new_logo.svg" alt="img" />
                </figure>
              </a>
            </div>
            <ul className="d-flex align-items-center justify-content-center">
              {/*<li>
                <a className="foot" href="/feature">Solutions</a>
              </li>*/}
              <li>
                <a className="foot" href="/Contactus">Contact Us</a>
              </li>
              <li>
                <a className="foot" href="/aboutus">About us</a>
              </li>
              {/*<li>
                <a className="foot" href="/FAQ">Faq</a>
              </li>*/}
            </ul>
            <hr />
            <div className="d-flex justify-content-center footer-nav-icon">
              {/* footer social icon  
              <div className="col-lg-3 col-md-3 d-flex align-items-center justify-content-md-start justify-content-sm-center justify-content-center">
                <div className="social-icon d-flex gap-2 justify-content-md-start justify-content-sm-center justify-content-center">
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-facebook-f foot-facebook" />
                  </a>
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-twitter" />
                  </a>
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-instagram" />
                  </a>
                </div>
              </div>
              */}
              {/* footer terms privacy  */}
              <div className="col-lg-6 col-md-6 d-flex justify-content-center align-items-center">
                <div className=" d-flex gap-3 p-2">
                  <a target="_blank" href="/assets/pdfs/Terms&Condition_Finkey.pdf" className="footer-terms">Terms &amp; Condition</a>
                  <a target="_blank" href="/assets/pdfs/Privacy_Policy_Finkey.pdf" className="footer-terms" >Privacy Policy</a>
                  <a target="_blank" href="/assets/pdfs/Refund_Policy_Finkey.pdf" className="footer-terms" >Refund Policy</a>
                </div>
              </div>
              {/* footer logo slider  */}
            </div>
            <hr />
            <div className="Copyright d-flex justify-content-between flex-wrap dir">
              <a className="footer-copyright">Copyright © 2024 FinkeyPay. All Right Reserved.</a>
              <a className="footer-copyright">FinkeyPay</a>
            </div>
          </div>
        </footer>
      </>

    </div>
  )
}
